import { render, staticRenderFns } from "./serviciosEvaluacionReconocimiento.vue?vue&type=template&id=e13be220&scoped=true"
import script from "./serviciosEvaluacionReconocimiento.vue?vue&type=script&lang=js"
export * from "./serviciosEvaluacionReconocimiento.vue?vue&type=script&lang=js"
import style0 from "./serviciosEvaluacionReconocimiento.vue?vue&type=style&index=0&id=e13be220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13be220",
  null
  
)

export default component.exports